/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VersionSyncInfo } from './versionSyncInfo';


export interface SyncVersionResponse { 
    /**
     * Total Number of deployments updated
     */
    deployments_updated: number;
    /**
     * List of version sync info
     */
    version_sync_info_list: Array<VersionSyncInfo>;
}

